import { t } from '@lingui/core/macro';
import { MetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const currencyFilterLabel = () => t({ message: 'Currency', comment: 'Insights filter: Currency' });
export function CurrencyFilter() {
    return <MetadataAllowedValuesFilter name="Currency" field="metadataDocumentCurrency" label={currencyFilterLabel()}/>;
}
